import loginComponentsModule from '../components/login-dialog/login-components.module';
import mobileConnectCallbackComponent from '../components/mobile-connect-callback/mobile-connect-callback.component';
import mobileConnectComponent from '../components/mobile-connect/mobile-connect.component';
import loginStateComponent from './login.component';
import routes from './login.routes';

export default angular
  .module('fizyweb.paycell.login', [loginComponentsModule])
  .component('login', loginStateComponent)
  .component('mobileConnect', mobileConnectComponent)
  .component('mobileConnectCallback', mobileConnectCallbackComponent)
  .config(routes).name;



// WEBPACK FOOTER //
// src/app/login/login.module.ts